import axios from 'axios'

export const sendEmail = ({emailData, reqBody, utm}) => {
  return axios.post('/api/contact', {
    turnstileToken: emailData['cf-turnstile-response'],
    to: emailData.to,
    subject: emailData.subject,
    message: emailData.message,
    reqBody,
    utm,
  })
}
